import React from 'react';
import { InCompleteTransactionModalContainer, SubTitle, Title } from './style';
import { ICancelExistingTransferModal } from '../../../utils/interface';
import { CANCEL_EXISTING_PENDING_TRANSACTION_MODAL } from '../../../utils/constants';
import { CommonButton } from '@Components';

const CancelExistingTransferModal: React.FC<ICancelExistingTransferModal> = (props) => {
  return (
    <InCompleteTransactionModalContainer>
      <Title>{CANCEL_EXISTING_PENDING_TRANSACTION_MODAL.heading}</Title>
      <SubTitle>{CANCEL_EXISTING_PENDING_TRANSACTION_MODAL.subHeading}</SubTitle>
      <CommonButton
        text={CANCEL_EXISTING_PENDING_TRANSACTION_MODAL.discardAndRestart}
        onClick={props.onContinue}
        type="primary"
        width={400}
      />
      <CommonButton
        text={CANCEL_EXISTING_PENDING_TRANSACTION_MODAL.goBack}
        onClick={props.onConfirm}
        type="secondary"
        width={400}
      />
    </InCompleteTransactionModalContainer>
  );
};

export default CancelExistingTransferModal;
